import { graphqlMainService } from "~/config/appConfig";

import { composeUrl } from "~/utils/composeUrl";

import { clientFactory } from "~/gql/clientFactory";

const httpUrl = composeUrl({
  hostname: graphqlMainService.hostname,
  protocol: graphqlMainService.protocolHttp,
  port: graphqlMainService.port,
  apiPrefix: graphqlMainService.apiPrefix,
});

const wsUrl = composeUrl({
  hostname: graphqlMainService.hostname,
  protocol: graphqlMainService.protocolWs,
  port: graphqlMainService.port,
  apiPrefix: graphqlMainService.apiPrefix,
});

export const client = clientFactory({ httpUrl, wsUrl, disableAuth: false });
export const clientNoAuth = clientFactory({
  httpUrl,
  wsUrl,
  disableAuth: true,
});
